import { Leaf, Sparkles, Heart } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-center max-w-2xl mx-auto fade-up">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">Our Story</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight">Made Slowly. Made With Love.</h1>
        <p className="text-muted-foreground mt-5 leading-relaxed">
          Candle Co. began in a tiny sunlit kitchen with a single pour, a wooden spoon, and the wish that ordinary evenings could feel a little more special. Today, we still pour every candle by hand — in small batches, from the calmest hours of our week.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10 mt-14 items-center">
        <img src="https://images.unsplash.com/photo-1635435605591-217d993deb88?w=1200&q=85"
          alt="Candle pouring" className="w-full h-auto rounded-3xl object-cover aspect-[5/4]" />
        <div>
          <h2 className="font-serif text-3xl sm:text-4xl mb-4">Slow, on purpose.</h2>
          <p className="text-muted-foreground leading-relaxed">
            Every candle spends 48 hours resting before it's approved for a home. We test each scent through three seasons before it earns a shelf. Because the little moments deserve unhurried craft.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-6 mt-16">
        <Value icon={<Leaf className="w-5 h-5" />} title="Clean Ingredients"
          text="100% natural soy wax, lead-free cotton wicks, phthalate-free essential oils. Nothing you can't pronounce." />
        <Value icon={<Heart className="w-5 h-5" />} title="Handpoured"
          text="Every candle is hand-poured in small batches by our tiny studio team. Slow, patient, human." />
        <Value icon={<Sparkles className="w-5 h-5" />} title="Kind to the Planet"
          text="Reusable glass vessels, recyclable packaging, zero paraffin. Refills and recycling encouraged." />
      </div>

      <div className="mt-16 p-8 sm:p-12 rounded-3xl bg-candle-cream border border-candle-caramel/30 text-center">
        <div className="font-serif text-2xl sm:text-3xl leading-relaxed italic text-candle-espresso">
          "A candle should feel like a small hug — quietly, in the corner, all evening."
        </div>
        <div className="mt-4 text-sm text-muted-foreground">— Ananya, Head Chandler</div>
      </div>
    </div>
  );
}

const Value = ({ icon, title, text }) => (
  <div className="p-6 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))]">
    <div className="w-10 h-10 rounded-full bg-candle-terracotta/15 text-candle-terracotta flex items-center justify-center mb-3">{icon}</div>
    <div className="font-serif text-xl mb-2">{title}</div>
    <p className="text-sm text-muted-foreground leading-relaxed">{text}</p>
  </div>
);
